import styled from 'styled-components'

const ContainerSectionSpecialtiesHorizontalScroll = styled.div`
  width: 100%;
  height: 100px;

  margin: 50px 0px 0px;

  background-color: var(--primary-color);

  color: white;

  display: flex;
  align-items: center;

  overflow-x: scroll;
  overflow-y: hidden;

  .specialties-scroll-item {
    margin: 0px 50px;
    font-size: 45px;
    line-height: 50px;

    width: fit-content;
    white-space: nowrap;

    font-weight: bold;
    animation: scroll 8s linear infinite;

    &.item-odd {
      -webkit-text-stroke: 1px white;
      color: transparent;
    }
  }

  @keyframes scroll {
    0% {
      transform: translateX(0);
    }
    100% {
      transform: translateX(-100%);
    }
  }
`

export default ContainerSectionSpecialtiesHorizontalScroll
